// extracted by mini-css-extract-plugin
export var animationAbsolute = "_31-q";
export var animationRelative = "_31-p";
export var backdropBlur = "_31-0";
export var detailLabelCell = "_31-12";
export var detailTable = "_31-11";
export var detailValueCell = "_31-13";
export var docIconBox = "_31-1d";
export var docIconBoxMd = "_31-1f";
export var docIconBoxSm = "_31-1e";
export var docTypeRow = "_31-16";
export var docTypeRowInner = "_31-17";
export var dropdownMatchDatePicker = "_31-3";
export var evidenceCardContent = "_31-1c";
export var fileUploadSpin = "_31-j";
export var gorgiasOpenButton = "_31-15 _31-d";
export var gorgiasTicketCard = "_31-14";
export var heroModalFooterButton = "_31-18";
export var hiddenContainer = "_31-o";
export var iconPrimary = "_31-1g";
export var iconSecondary = "_31-1h";
export var iconTertiary = "_31-1i";
export var integrationCard = "_31-1";
export var integrationLogoBox = "_31-2";
export var mainColumnSticky = "_31-1b";
export var maxWidthContainer = "_31-19";
export var modalContentBody = "_31-a";
export var modalHeaderImage = "_31-5";
export var modalImageLabel = "_31-7";
export var modalImageOverlay = "_31-6";
export var modalImageSubtitle = "_31-9";
export var modalImageTitle = "_31-8";
export var modalImageWrapper = "_31-4";
export var modalStickyFooter = "_31-b";
export var removeButton = "_31-e";
export var sidebarColumn = "_31-1a";
export var spinner = "_31-i";
export var timelineLine = "_31-y";
export var timelineLineBlack = "_31-10 _31-y";
export var timelineLineGray = "_31-z _31-y";
export var timelineLineHeight = "_31-x";
export var tlDotActivate = "_31-u";
export var tlDotActivateAnim = "_31-t";
export var tlDotHide = "_31-s";
export var tlDotHideAnim = "_31-r";
export var tlLineActivate = "_31-w";
export var tlLineActivateAnim = "_31-v";
export var uploadHint = "_31-n";
export var uploadIconBox = "_31-k";
export var uploadLabel = "_31-m";
export var uploadText = "_31-l";
export var uploadZone = "_31-f";
export var uploadZoneCursorDefault = "_31-h";
export var uploadZoneCursorPointer = "_31-g";
export var uploadedFileRow = "_31-c";
export var viewButton = "_31-d";